import { BadgeCheck, BookOpen, Github, SquareTerminal } from "lucide-react";
import { ASSETS } from "@zkresistor/client";
import { MtongaFlag } from "./MtongaFlag";
import { PROJECT } from "./project";

const links = [
  { label: "Docs", href: "/docs/", icon: BookOpen, external: false },
  { label: "Resistance Tools", href: PROJECT.links.resistanceTools, icon: () => <span className="app-footer-telegram-icon" aria-hidden="true" />, external: true },
  { label: "GitHub", href: PROJECT.links.contracts, icon: Github, external: true },
  { label: "CLI", href: PROJECT.links.cli, icon: SquareTerminal, external: true },
  { label: "TON Verifier", href: PROJECT.links.verifier, icon: BadgeCheck, external: true },
] as const;

export function Footer() {
  return <footer className="app-footer">
    <div className="app-footer-inner">
      <a className="app-footer-ton" href={PROJECT.links.ton} target="_blank" rel="noreferrer noopener" aria-label="The Open Network">
        <img src={ASSETS.ton} alt="TON" />
      </a>
      <nav className="app-footer-links" aria-label="Project links">
        {links.map(({ label, href, icon: Icon, external }) => <a key={label} href={href} target={external ? "_blank" : undefined} rel={external ? "noreferrer noopener" : undefined}><Icon aria-hidden="true" /><span>{label}</span></a>)}
      </nav>
      <span className="app-footer-mtonga" title="Made in Tonga"><span>MTONGA</span><MtongaFlag /></span>
    </div>
  </footer>;
}
